import React from "react";
import styles from "./aside_tel_list.module.css";


function AsideTelList ({
  checkTelList,
  phones
}) {

  return (
    <ul className={`${styles.menu} ${checkTelList && styles.menuOpened}`}>
      { phones.map((phone) => {
        return (
          <li key={`${phone.id}`} className={`${styles.item}`}>
            <div className={styles.textContainer}>
              <p className={styles.telName}>{phone.name}:</p>
              <p className={styles.telNum}>{phone.num}</p>
            </div>
            <div className={styles.linksContainer}>
              <a href={`tel:${phone.federal_num}`} className={styles.tel}>
                <div className={styles.icon} />
              </a>
              { phone.in_viber &&
                <a href={`viber://chat?number=${phone.federal_num}`} className={styles.tel}>
                  <div className={styles.iconViber} />
                </a>
              }
              { phone.in_whatsapp &&
                <a href={`whatsapp://send?phone=${phone.federal_num}`} className={styles.tel}>
                  <div className={styles.iconWhatsapp} />
                </a>
              }
              { phone.telegram_name &&
                <a href={`tg://resolve?domain=${phone.telegram_name}`} className={styles.tel}>
                  <div className={styles.iconTelegram} />
                </a>
              }
            </div>
          </li>

        )
      }) }
    </ul>
  );
}

export default AsideTelList;
